<template>
  <div v-if="activeTab === 'reasons'" class="card card-outline-primary rounded-3 shadow">
    <div class="card-body p-0 px-4 py-3">
      <div class="d-flex justify-content-between align-items-center">
        <ul class="card-progress-tracker fw-bold text-center mb-0">
          <li :class="(workflowData && workflowData.workflow_completed && workflowData.workflow_completed.reason_for_usage_exists) ? 'completed': 'in-completed'">
            Reason for Workflow Provided
          </li>
        </ul>
      </div>
      <transition name="slide-fade">
        <div v-if="workflowData && workflowData.workflow_completed && workflowData.workflow_completed.reason_for_usage_exists" class="modern-list mt-3">
          <hr class="fw-light" />
          <ul class="list-group">
            <li :class="['list-group-item d-flex justify-content-between align-items-center text-xs py-4 border-0', index !== workflowData.list_reasons.length - 1 ? 'border-bottom' : '']" v-for="(reason, index) in workflowData.list_reasons" :key="index">
              <span v-if="reason.is_selected == true">
                <i class="fas fa-chevron-right text-primary me-2"></i>
                {{ reason.usage__reason }}
              </span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReasonsTab',
  props: {
    activeTab: {
      type: String,
      default: 'reasons'
    },
    workflowData: {
      type: Object,
      default: null
    }
  }
}
</script>

<style scoped></style>
